export default __webpack_public_path__ + "static/sample0-c0b7da36d2856d28af457fbedee4de5e.webp";